// Contenido de la guia: id de servicio -> { que, patron, nodos, grupo, pasos, objetos } (contenido/cNN, un archivo por categoria)
// mas el material complementario { nivel, cuando, evita, alt, cobro, con, quiz, falla } (extra/eNN).
import c01 from "./c01-computo";
import c02 from "./c02-almacenamiento";
import c03 from "./c03-bases-de-datos";
import c04 from "./c04-redes";
import c05 from "./c05-seguridad";
import c06 from "./c06-integracion";
import c07 from "./c07-gestion";
import c08 from "./c08-costos";
import c09 from "./c09-analisis";
import c10 from "./c10-ml";
import c11 from "./c11-desarrollo";
import c12 from "./c12-migracion";
import c13 from "./c13-usuario-iot";
import e01 from "../extra/e01-computo";
import e02 from "../extra/e02-almacenamiento";
import e03 from "../extra/e03-bases-de-datos";
import e04 from "../extra/e04-redes";
import e05 from "../extra/e05-seguridad";
import e06 from "../extra/e06-integracion";
import e07 from "../extra/e07-gestion";
import e08 from "../extra/e08-costos";
import e09 from "../extra/e09-analisis";
import e10 from "../extra/e10-ml";
import e11 from "../extra/e11-desarrollo";
import e12 from "../extra/e12-migracion";
import e13 from "../extra/e13-usuario-iot";

const base = { ...c01, ...c02, ...c03, ...c04, ...c05, ...c06, ...c07, ...c08, ...c09, ...c10, ...c11, ...c12, ...c13 };
const extra = { ...e01, ...e02, ...e03, ...e04, ...e05, ...e06, ...e07, ...e08, ...e09, ...e10, ...e11, ...e12, ...e13 };

const todo = {};
Object.keys(base).forEach(id => { todo[id] = { ...base[id], ...(extra[id] || {}) }; });
export default todo;
